import { Controller } from '@hotwired/stimulus'
import { Chart, DoughnutController, ArcElement, Tooltip, Legend } from 'chart.js'
import { CHART_COLORS } from '../lib/chart_colors'

Chart.register(DoughnutController, ArcElement, Tooltip, Legend)

export default class extends Controller {
  static targets = ['canvas']
  static values = {
    data: Array,
    labels: Array,
    colors: { type: Array, default: [CHART_COLORS.primary, CHART_COLORS.primaryLight] },
  }

  connect() {
    this.chart = new Chart(this.canvasTarget, {
      type: 'doughnut',
      data: {
        labels: this.labelsValue,
        datasets: [{
          cutout: '60%',
          borderWidth: 3,
          backgroundColor: this.colorsValue,
          data: this.dataValue,
        }],
      },
      options: {
        responsive: true,
        plugins: {
          tooltip: {
            displayColors: false,
            callbacks: {
              label: (context) => `${context.raw} % - ${context.label}`,
            },
          },
          legend: {
            display: false,
          },
        },
      },
    })
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }
}
